<!-- 客户信息管理 -->
<template>
    <basicContainer>
        <avue-crud ref="avueCrud" :data="tableData" :search.sync="search" :option="option" v-model="form" :table-loading="TABLE_LOADING" :page.sync="TABLE_PAGE" @search-change="SEARCH_CHANGE" @refresh-change="TABLE_REFRESH" @search-reset="SEARCH_RESET" @cell-click="CELL_CLICK" @selection-change="SELECTION_CHANGE" @sort-change="SORT_CHANGE" @size-change="SIZE_CHANGE" @current-change="CURRENT_CHANGE" :before-open="beforeOpen" :before-close="beforeClose" @row-update="rowUpdate" @row-save="rowSave" @row-del="rowDel">
             <template v-slot:menuLeft>
              <el-button type="primary" size="small" @click="addClientele()">添加客户信息</el-button>
              <el-button type="primary" size="small" @click="exportProps.dialogVisible = true">导出</el-button>
            </template>
            <template v-slot:menu="{type,size,row}">
                <el-button size="small" type="text" icon="el-icon-view" @click.stop="view(row)">查看</el-button>
                <el-button size="small" type="text" icon="el-icon-edit" @click.stop="edit(row)">编辑</el-button>
            </template>
        </avue-crud>
        <!--导出弹窗 -->
      <exportModel
        :exportProps="exportProps"
        @download="download"
      ></exportModel>
    </basicContainer>
</template>

<script>
import exportModel from '@/businessManagement/components/exportModel.vue'
import crudPageMinix from '@/businessManagement/utils/crudPageMinix.js'
import { dateFormat } from '@/framework/util/date'
export default {
  name: 'CustomerInformationManagement',
  mixins: [crudPageMinix],
  components: { exportModel },
  data() {
    return {
      formid: '', // 流程表单ID
      option: {
        stripe: true,
        border: true,
        page: true,
        selection: true,
        index: true,
        indexLabel: '序号',
        tip: false,
        align: 'left',
        menuAlign: 'center',
        searchMenuSpan: 6,
        columnBtn: false,
        refreshBtn: true,
        labelWidth: 170,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menu: true,
        menuWidth: 140,
        column: [
          {
            label: '创建时间',
            prop: 'cjDate',
            hide: true,
            search: false,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            searchRange: true,
            searchClearble: true,
            searchSpan: 8,
            viewDisplay: false
          },
          /*{
            label: '客户名称/联系人/联系电话',
            prop: 'name',
            search: false,
            hide: true,
            searchLabelWidth: 200,
            searchSpan: 10,
            minWidth: 200
          },*/
          {
            label: '客户名称',
            prop: 'name',
            search: true,
            searchLabelWidth: 100,
            minWidth: 200
          },
          {
            label: '客户简称',
            prop: 'khjc',
            searchLabelWidth: 100,
            minWidth: 200
          },
          {
            label: '客户联系人',
            prop: 'contacts',
            // search: true,
            searchLabelWidth: 100,
            minWidth: 100
          },
          {
            label: '所属部门',
            prop: 'department',
            minWidth: 140,
            hide: true
          },
          {
            label: '销售员',
            prop: 'xsn',
            minWidth: 100
          },
          {
            label: '邮箱',
            prop: 'email',
            minWidth: 150,
            hide: true
          },
          {
            label: '联系电话',
            prop: 'phone',
            minWidth: 100,
            hide: true
          },
          {
            label: '创建时间',
            prop: 'create_time',
            minWidth: 140
          }
        ]
      },
      form: {},
      tableData: [],
      //   导出参数
      exportProps: {
        filename: '客户信息统计表_' + dateFormat(new Date(), 'yyyy-MM-dd'),
        dialogVisible: false
      }
    }
  },
  mounted() {
    var date = new Date()
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }
    let rq = year + '-' + month + '-' + day
    setTimeout(() => {
      //this.$set(this.search, 'cjDate', [rq, rq])
      this.loadData()
    }, 500)
  },
  methods: {
    loadData(
      TABLE_PAGE = this.TABLE_PAGE,
      QUERY_CONDITIONS = this.QUERY_CONDITIONS,
      TABLE_ORDER = this.TABLE_ORDER,
      done
    ) {
      this.TABLE_LOADING = true // 表格转圈
      var params = {}
      if (this.search.cjDate && this.search.cjDate.length == 2) {
        params.kssj = this.search.cjDate[0]
        params.jssj = this.search.cjDate[1]
      }
      params.name = this.search.name
      this.$http.post('/CustomerInformation/query',
        QUERY_CONDITIONS,
        {
          params: {
            ...params,
            pageNum: TABLE_PAGE.currentPage,
            pageSize: TABLE_PAGE.pageSize
          }
        })
        .then((response) => {
          this.RELOAD_CRUD(response.data.records)
          this.TABLE_PAGE.total = response.data.total || response.data.records.length
          this.SELECT_LIST = []
        })
        .catch((error) => {
          this.$message.error(error.msg || error.message)
        })
        .finally(() => {
          this.TABLE_LOADING = false // 表格转圈
          typeof done === 'function' && done()
        })
    },
    view(row) {
      row.businessKey = row.id
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.businessKey,
          processInstanceId: null,
          taskId: null,
          formId: 'e9217ab045384b279d31c1b858a8aef9',
          pageKey: 'VIEW'
        }
      })
    },
    edit(row) {
      row.businessKey = row.id
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.businessKey,
          processInstanceId: null,
          taskId: null,
          formId: 'e9217ab045384b279d31c1b858a8aef9',
          pageKey: 'DO'
        }
      })
    },
    addClientele() {
      this.$router.push('/applyForm?businessKey=&processInstanceId&taskId&formId=e9217ab045384b279d31c1b858a8aef9&pageKey=DO')
    },
    download(fileName, done) {
      var params = {}
      if (this.search.cjDate && this.search.cjDate.length == 2) {
        params.kssj = this.search.cjDate[0]
        params.jssj = this.search.cjDate[1]
      }
      params.name = this.search.name
      this.$downloadFile.post('/CustomerInformation/exportInventory', params,
        {
          params: {
            doDownload: true,
            fileName
          }
        }
      )
        .then((res) => {})
        .catch((error) => {
          this.$message.error(error.msg || error.message)
        })
        .finally(() => {
          done()
        })
    }
  }
}
</script>

